import React, { useRef } from "react";
import { Link } from "react-router-dom";
import { motion, useInView } from "framer-motion";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import hospital from '../Components/img/hero2.png'
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { Container } from "react-bootstrap";
import Carrousel from './img/Carousel3.jpg'
import { Helmet } from 'react-helmet';


const About = ({ title, description, buttonLink, imageSrc }) => {
 
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true });  


  return (
    <div className="container py-5" ref={ref}>
  <Helmet>
        <title>{title || "Dr. Swati Chavhan Vanjari - About Us"}</title>
        <meta name="google-site-verification" content="hDy2TyO5-XOsY-kqHa_AsfhwAKrzVrvGjXLKbQkdVlw" />
        <meta name="description" content={description || "Dr. Swati Chavhan Vanjari is a consultant neuropsychiatrist and REBT therapist specializing in mental health care."} />
        <meta name="keywords" content="Dr. Swati Chavhan, neuropsychiatrist, mental health, therapist, psychiatry, REBT" />
      </Helmet>

      <Container className="row align-items-center bg-light p-4 ">

        {/* Image Section */}
        <motion.div
          className="col-md-6"
          initial={{ opacity: 0, x: 50 }}
          animate={isInView ? { opacity: 1, x: 0 } : {}}
          transition={{ duration: 0.8 }}
        >
          <motion.img
            src={imageSrc || hospital}
            alt="Hospital"
            className="img-fluid rounded-md image-hover-effect mb-1"
            whileHover={{ scale: 1.05 }}
            transition={{ duration: 0.3 }}
          />
        </motion.div>

        {/* Text Content */}
        <motion.div
          className="col-md-6 mb-4"
          initial={{ opacity: 0, x: -50 }}
          animate={isInView ? { opacity: 1, x: 0 } : {}}
          transition={{ duration: 0.8 }}

        >
          <h6 className="text-success"style={{fontStyle:'inherit'}}>Serving 50,000+ Patients Since 2015</h6>
          <h3 style={{ fontFamily:'sans-serif', fontWeight: 'bold', fontSize: '40px' }} className="text-black text-4xl font-bold mb-3">
            {title || "Dr.Swati Chavhan Vanjari "}
          </h3>

          <h2>Consultant Neuropsychiatrist & REBT Therapist </h2>

          <p className="text-muted"style={{fontSize:'23px'}}>
            {description ||
              "we offer comprehensive mental health care with a focus on treating both neurological and psychiatric conditions. Our team includes a highly skilled Consultant Neuropsychiatrist who specializes in the intersection of neurology and psychiatry."}
          </p>
          <Link to={buttonLink || "/about"}>
            <button className="group relative px-7 py-2 font-medium text-white hover:text-yellow-900">
              <span className="absolute inset-0 h-full w-full translate-x-0 -skew-x-12 transform bg-cyan-600 transition-all duration-300 ease-out group-hover:skew-x-0 group-hover:bg-yellow-700"></span>
              <span className="absolute inset-0 h-full w-full skew-x-12 transform bg-blue-900 transition-all duration-300 ease-out group-hover:-skew-x-0 group-hover:bg-cyan-600"></span>
              <span className="relative">Quick Enquiry</span>
            </button>
          </Link>
        </motion.div>

      </Container>
      <Container className="mt-5">
        <Row>
          {/* Column 1 */}
          <Col xs={12} md={4}>
            <h1 style={{ color: '#23486A', fontWeight: 'bold', fontSize: '30px' }} className="mb-3">
              Education & Expertise
            </h1>

            <p style={{ fontSize: '17px' }}>
              With a robust educational background and extensive clinical experience,dedicated to providing comprehensive psychiatric care tailored to the unique needs of each patient.
              <li>DPM (Diploma in Psychiatric Medicine) – GS Medical College, KEM Hospital, Mumbai
              </li>
              <li>MBBS – TNMC & Nair Hospital, Mumbai</li>
            </p>
            <h3>Contributions</h3>
            <p style={{ fontSize: '17px' }}>
              <li><b>Mental Health Awareness:</b> Dr.Swati Chavhan Vanjari  has conducted over 400 sessions on mental health awareness, educating communities and healthcare professionals on various mental health topics.</li>
              <li><b>Consultancy for UNICEF & TCS:</b> Acted as an expert guide for mental health projects with UNICEF and Tata Consultancy Services (TCS), contributing valuable insights to global initiatives in mental health.</li>
            </p>
          </Col>

          {/* Column 2 */}
          <Col xs={12} md={4} className="mb-4">
            <h2 style={{ color: '#23486A', fontWeight: 'bold', fontSize: '30px' }}>
              How I Work
            </h2>
            <img src={Carrousel} alt="Carousel" className="img-fluid rounded-md image-hover-effect mb-4" />
            <p style={{ fontSize: '17px' }}>
              my approach is centered around the belief that every individual is unique, and so is their path to mental well-being. I strive to create a compassionate, non-judgmental space where you can feel heard, understood, and empowered to make positive changes in your life.

              Here’s how I work to support your journey to mental and emotional well-being
            </p>

          </Col>

          {/* Column 3 */}
          <Col xs={12} md={4}>
            <h2 style={{ color: '#23486A', fontWeight: 'bold', fontSize: '30px' }} className="mb-2">
              Why Choose us
            </h2>
            <h3>Specialized Training </h3>
            <p style={{ fontSize: '17px' }}>
              <li>10 Years of Expertise – Sion Hospital, Mumbai, with hands-on experience in managing various psychiatric and neuropsychiatric cases.</li>
              <li>Deaddiction Treatment Training – Bombay Drug Deaddiction Centre of Excellence, KEM Hospital, Mumbai.</li>
            </p>
            <h3 style={{ fontFamily: 'inherit' }}>Certifications</h3>
            <p style={{ fontSize: '17px' }}>
              <li> Certified in REBT (Rational Emotive Behavior Therapy) – Under the expert guidance of Mrs. Swati Khanolkar, affiliated with the Albert Ellis Institute, New York, USA.</li>
              <li> Positive Psychology Course – Completed from Harvard University, Massachusetts.</li>
            </p>
            <h3 style={{ fontFamily: 'inherit' }}>Areas of Specialization</h3>
            <p style={{ fontSize: '17px' }}>
              <li> <b>Female and Geriatric Psychiatry: </b>Expertise in managing psychiatric cases in women and older adults, ensuring personalized and compassionate care.</li>
              <li><b>Deaddiction Treatment:</b> Skilled in the treatment of substance abuse and addiction, with specialized training in handling complex addiction cases.</li>
              <li><b>Psychiatric Disorders: </b>Experience in managing a wide range of psychiatric conditions</li>

            </p>
          </Col>
        </Row>
      </Container>
      <div className="container py-5">
        <h2 className="text-center text-dark font-weight-bold mb-4">
          Our Successful Mission
        </h2>
        <div className="row text-center">
          {/* Success Therapies */}
          <div className="col-md-6 mb-4">
            <div className="p-4 border rounded shadow-sm bg-light">
              <h3 className=" font-weight-bold">400+</h3>
              <p className="mb-0">Successful Therapies</p>
            </div>
          </div>
          {/* Years of Experience */}
          <div className="col-md-6 mb-4">
            <div className="p-4 border rounded shadow-sm bg-light">
              <h3 className=" font-weight-bold">10+ Years</h3>
              <p className="mb-0">Years of Experience</p>
            </div>
          </div>
        </div>
      </div>
    </div>


  );
};

export default About;
